import { render, staticRenderFns } from "./BlackRoyaltyReportAdmin.vue?vue&type=template&id=1a344b5b"
import script from "./BlackRoyaltyReportAdmin.vue?vue&type=script&lang=js"
export * from "./BlackRoyaltyReportAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports